$(document).ready(function() {
	if(!document.querySelector('.email-common')) return false;
	
	var emailCeo = {
		localeCode: document.getElementsByTagName("html")[0].getAttribute("data-countrycode"),
	    init: function(){
        	
        	$("#ceoQuestionSubType option:eq(0)").prop("selected", true).trigger('chosen:updated');
        	emailCeo.addEvent(); 
        	
        	if( emailCeo.localeCode == "es" ||  emailCeo.localeCode == "ca_en" ||  emailCeo.localeCode == "ca_fr" ||  emailCeo.localeCode == "pl" ||  emailCeo.localeCode == "mx"){
        		$("#btnType1").click();
        	}
		},
		
		addEvent: function(){
			var _model = $(".your-product");
			var _form = $("#emailSendingForm");
			var addCls = "btn-secondary";
			var rmCls = "btn-outline-secondary";
			var _btnType1 = $("#btnType1");
			var _btnType2 = $("#btnType2");
			var _btnType3 = $("#btnType3");
			
			$(_btnType1).on('click', function(e){
				_form.find("#ceoQuestion").val("1");
				_btnType1.removeClass(rmCls);
				_btnType2.removeClass(addCls);
				_btnType3.removeClass(addCls);
				_btnType1.addClass(addCls);
				
				_model.removeClass("d-none");
				_form.removeClass("d-none");
				
				emailCeo.myProductListChk();
			});
			
			$(_btnType2).on('click', function(e){
				_form.find("#ceoQuestion").val("2");
				_btnType1.removeClass(addCls);
				_btnType2.removeClass(rmCls);
				_btnType3.removeClass(addCls);
				_btnType2.addClass(addCls);
				
				_model.removeClass("d-none");
				_form.removeClass("d-none");
				
				emailCeo.myProductListChk();
			});
			
			$(_btnType3).on('click', function(e){
				_form.find("#ceoQuestion").val("3");
				_btnType1.removeClass(addCls);
				_btnType2.removeClass(addCls);
				_btnType3.removeClass(rmCls);
				_btnType3.addClass(addCls);
				
				_model.removeClass("d-none");
				_form.removeClass("d-none");
				
				emailCeo.myProductListChk();
			});
			
			$("#ceoQuestionSubType").on('change', function(e){
				_form.find("#ceoQuestionSub").val($("#ceoQuestionSubType").val());
			});
		},
		
		myProductListChk: function(){
			if($('#myProductList').length>0 && $('#myProductList').is(':visible')) {
				setTimeout(function(){
					$('#myProductList .items').slick('setPosition');
				}, 80);
			}
		}
		
	}
	
	
	emailCeo.init();
});
